// Entry point for the build script in your package.json
if (!window.Turbo) {
  require("@hotwired/turbo-rails");
}
import * as ActiveStorage from "@rails/activestorage";
import "../components";
import Video from "../javascript/external/video.js";
import "./controllers";
ActiveStorage.start;
window.Video = Video;

// Change default Confirmation modal
Turbo.setConfirmMethod((message, element) => {
  let dialog = document.getElementById("turbo-confirm");
  dialog.querySelector(".title").textContent = message;
  if (element.dataset.confirmMessage) {
    dialog.querySelector(".message").textContent =
      element.dataset.confirmMessage;
  }
  dialog.classList.remove("hidden");

  return new Promise((resolve, reject) => {
    dialog.querySelectorAll("button").forEach((button) => {
      button.addEventListener(
        "click",
        (e) => {
          dialog.classList.add("hidden");
          resolve(e.currentTarget.value == "confirm");
        },
        { once: true },
      );
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const overlay = document.createElement('div');
  overlay.id = 'loading-overlay';
  overlay.className = 'loading-overlay';

  const spinner = document.createElement('div');
  spinner.className = 'loading-spinner';

  overlay.appendChild(spinner);
  document.body.appendChild(overlay);
});
